/**
 * Бухгалтерия подарка в детализации заказа.
 *
 * Подарочное блюдо лежит в позициях по ПОЛНОЙ цене (так его видит касса), а его
 * стоимость гасится статьёй `giftTierDiscount` в шапке заказа. Раньше детализация
 * показывала это двумя несвязанными фактами: платная строка блюда + строка
 * «Подарок −260 ₽». Гость не понимал, что именно ему подарили, и выглядело так,
 * будто с него взяли деньги за подарок.
 *
 * Бэкенд теперь помечает саму строку (`isGift` + `giftDiscount`), поэтому скидку
 * показываем ровно один раз — в строке. Отдельная строка «Подарок» остаётся только
 * как фолбэк: старый бэкенд без пометки, или подарочного товара уже нет в позициях.
 *
 * Бесплатна ровно ОДНА единица: `giftDiscount` — цена одной штуки, поэтому при
 * количестве 2 строка стоит `totalPrice − giftDiscount`, а не ноль.
 */

/** Сколько рублей позиции покрыто подарком (0, если позиция не подарочная) */
export const getItemGiftDiscount = (item: any): number => {
  if (!item?.isGift) return 0
  const discount = Number(item.giftDiscount ?? 0)
  return Number.isFinite(discount) && discount > 0 ? discount : 0
}

/** Признак подарочной позиции */
export const isGiftItem = (item: any): boolean => !!item?.isGift

/** Стоимость позиции к оплате: цена строки за вычетом подарочной единицы */
export const getItemPayablePrice = (item: any): number => {
  const total = Number(item?.totalPrice ?? item?.total_price ?? 0)
  const safeTotal = Number.isFinite(total) ? total : 0
  return Math.max(0, safeTotal - getItemGiftDiscount(item))
}

/** Суммарная скидка, уже разнесённая по строкам позиций */
export const getAttributedGiftDiscount = (items: any[]): number => {
  if (!Array.isArray(items)) return 0
  return items.reduce((sum, item) => sum + getItemGiftDiscount(item), 0)
}

/**
 * Остаток подарочной скидки, который НЕ удалось привязать к строке, — его
 * по-прежнему показываем отдельной строкой, иначе детализация не сойдётся с итогом.
 */
export const getUnattributedGiftDiscount = (
  giftTierDiscount: number | undefined,
  items: any[],
): number => {
  const total = Number(giftTierDiscount ?? 0)
  if (!Number.isFinite(total) || total <= 0) return 0
  return Math.max(0, total - getAttributedGiftDiscount(items))
}
